import React from 'react'
import { useHistory } from 'react-router'

import { FilterControls, useInitialFilters } from './FilterControls'
import { useFilteredCalendarEvents } from './useFilteredCalendarEvents'

import { CalendarCourtReporterEvent, CourtReporter } from '@/apiClient'
import { CourtReporterOwnCalendarEvent } from '@/components/Calendar/CourtReporterOwnCalendarEvent'
import { CalendarScreen } from '@/components/CalendarScreen'
import { useCourtReporter } from '@/providers/UserProvider'
import {
  CalendarParams,
  toCalendarParamsPath,
  useCalendarParams,
} from '@/queries/useCalendarParams'
import { NotFound } from '@/routes/NotFound'

export const Dashboard = () => {
  const calendarParams = useCalendarParams()
  const courtReporter = useCourtReporter()

  if (!courtReporter) {
    return null
  }

  if (!calendarParams) {
    return <NotFound />
  }

  return (
    <DashboardScreen
      calendarParams={calendarParams}
      courtReporter={courtReporter}
    />
  )
}

const DashboardScreen: React.FC<{
  calendarParams: CalendarParams
  courtReporter: CourtReporter
}> = ({ calendarParams, courtReporter }) => {
  const history = useHistory()
  const initialFilters = useInitialFilters({
    court_reporter_status_in: ['booked', 'past'],
  })

  const { events, filters, setFilters, isFetching } = useFilteredCalendarEvents(
    {
      courtReporterId: courtReporter.id,
      calendarParams,
      initialFilters,
    },
  )

  return (
    <CalendarScreen
      events={events}
      initialView={calendarParams.view}
      initialDate={calendarParams.date}
      renderEvent={(event, { view }) => (
        <CourtReporterOwnCalendarEvent
          event={event as CalendarCourtReporterEvent}
          view={view}
        />
      )}
      onStateChange={({ date, view }) => {
        if (view === 'listCustom') {
          return
        }

        history.push(`/calendar/${toCalendarParamsPath(view, date)}`)
      }}
      isLoading={isFetching}
      hotkeysEnabled={true}
      sidebar={<FilterControls values={filters} onChange={setFilters} />}
    />
  )
}
